import { appConfig as $config } from '@App/app.config';
import { fUploader } from '@Modules/fUploader';
import { assetsManager } from '@Modules/assetsManager/artworks';
import { App } from '@Modules/App';
import { UI } from '@Modules/UI';
import { User } from '@Modules/User';

export const patternArtwork = (function () {
  let $fup = null;

  let init = (artwork) => {
    $('#addFileFileType-select').select2().on('select2:select', (e) => {
      removeFiles();

      let letter = $(e.target).val() * 1;

      if (letter < 0) {
        $fup = new fUploader('input[type="file"]', { disabled: true });
        $('#filesRequirements').empty();
        return;
      }

      $('#filesRequirements').html($lang.filesModel[letter].requirements);

      $fup = new fUploader('input[type="file"]', {
        ...$config.filesModel[letter],
        ...{
          pageType: 'artworks',
          blockEl: '.pattern-artwork-file .fileuploader',
          autostart: true,
          validate: (data) => {
            if (!data) {
              removeFiles();
            }
          },
          complete: generateFiles
        }
      });
    });

    initFileLoader(artwork);
  };

  let initFileLoader = (artwork) => {
    if (!artwork?.id) {
      $('#addFileFileType-select').val(1).trigger('select2:select');

      return;
    }

    const colorGroup = artwork.versionFiles.find(f => f.colorGroup === 'All') || artwork.versionFiles[0];

    const file = colorGroup.files.find(f => f.fileType === 1);
    const srcFile = colorGroup.files.find(f => f.additionalValues?.srcFile === true || f.additionalValues?.srcFile === 'True');

    const letter = srcFile.fileType;

    const uploadFilePreview = {
      name: srcFile.fileName,
      file: file.uri,
      size: 0,
      type: 'image/png',
    };

    $('#filesRequirements').html($lang.filesModel[letter].requirements);
    $('#addFileFileType-select').val(letter).trigger('change');

    $fup = new fUploader('input[type="file"]', {
      files: uploadFilePreview,
      ...$config.filesModel[letter],
      ...{
        pageType: 'artworks',
        blockEl: '.pattern-artwork-file .fileuploader',
        completeOnRemove: true,
        complete: () => {
          setTimeout(() => $('#addFileFileType-select').val(letter).trigger('select2:select'));
        }
      }
    });
  };

  let removeFiles = () => {
    const previousVersionFilesStringified = App.pageData('currenteditedcontent.versionFilesStringified');
    App.pageData('currenteditedcontent.versionFilesStringified', '[]');

    if (previousVersionFilesStringified !== '[]') {
      App.pageData($config.GLOBAL.UNSAVED_CHANGES, true);
    }
  };

  let generateFiles = (data) => {
    if (!data) {
      return;
    }

    UI.block('.pattern-artwork-file .fileuploader');

    assetsManager.createFiles(data[0]).then((res) => {
      UI.unblock('.pattern-artwork-file .fileuploader');

      if (res.isSuccess) {
        // Set SourceFile flag in additionalValues
        data[0].additionalValues.srcFile = true;

        res.filesResult.forEach((element) => {
          data.push({ ...element, IsAdd: true, partType: 3 });
        });

        const files = data.map((file) => ({
          partType: 3,
          fileName: file.fileName,
          fileStorageName: file.fileStorageName,
          folderName: 'artworks',
          containerName: User.accountID(),
          uri: file.uri,
          fileType: file.fileType,
          additionalValues: file.data?.additionalValues || file.additionalValues || {},
          thumbnailImageUri: null,
          IsAdd: file.IsAdd
        }));

        const versionFiles = [{
          files,
          name: 'All',
          colorGroup: 'All',
          thumbnailImageUri: files[0].uri,
          systemGenerated: false
        }];

        App.pageData('currenteditedcontent.versionFilesStringified', JSON.stringify(versionFiles));

        App.pageData($config.GLOBAL.UNSAVED_CHANGES, true);
      }
    });
  };

  let isValid = () => {
    const savedVersionFiles = JSON.parse(App.pageData('currenteditedcontent.versionFilesStringified') || '[]');

    if (!savedVersionFiles.length) {
      missingPatternArtworkFileDialog();
      UI.scrollToElement('.pattern-artwork-file');

      return false;
    }

    return true;
  };

  let missingPatternArtworkFileDialog = () => {
    bootbox.dialog({
      title: '<i class="fal fa-exclamation-triangle text-danger mr-2"></i> ' + $lang.artwork.Warning,
      message: 'Missing Pattern-Artwork File',
      buttons: {
        Ok: {
          label: $lang.btn.ok,
          className: 'btn btn-danger',
        }
      }
    });
  };

  return {
    init,
    isValid
  };
})();
